import * as Constants from './AlmeInlineConstants';
export const isInlineFormResponse = (response) => !!(response && getInlineFormResponseAction(response));
export function getInlineFormResponseAction(response) {
    var _a;
    return (_a = response.responseActions) === null || _a === void 0 ? void 0 : _a.find((respAction) => respAction.Name === Constants.LAUNCHPICKERINPUT || respAction.Name === Constants.LAUNCHDATEPICKERINPUT || respAction.Name === Constants.LAUNCHPICKERMULTISELECT || respAction.Name === Constants.LAUNCHAUTOSEARCHBOX);
}
